import React, { useContext, useRef, useState } from "react";
import "./index.scss"; // Your SCSS file for styling
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import ProductGrid from "../../components/ProductGrid";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useStore } from "react-redux";
import { Store } from "@reduxjs/toolkit";
import { calculateTotal } from "../../utils";
import Modal from "react-modal";
import ModalViderBasket from "../../components/ModalViderBasket";
import { UserContext } from "../../components/context/userContext";
import { api } from "../../config/baseApi";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "40vh",
    borderWidth: 0.2,
    borderRadius: 12,

    background: `linear-gradient(269deg, #F1FFFC 0%, #FFFCF7 100%), #FFF`,
  },
};
function CartScreen() {
  // The rest of your component logic...
  const { isAuthenticated } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<any>();
  const productsInBasket = useSelector(
    (state: Storage) => state?.entities?.basketSlice?.product,
  );
  const store = useStore() as Store;
  const scrollContainerRef = useRef(null);

  const navigate = useNavigate();

  const ViderPanierAction = () => {
    setIsOpen(true);
  };

  const deleteItem = (item: any) => {
    setItemToDelete(item);
    setIsOpenDelete(true);
  };

  const removeProdFromBasket = () => {
    try {
      store.dispatch({
        type: "basketSlice/deleteOneProd",
        payload: { productId: itemToDelete?._id },
      });
      closeModalDelete();
    } catch (error) {
    }
  };
  const increaseQuantity = (item: any) => {
    try {
      store.dispatch({
        type: "basketSlice/increaseQuantity",
        payload: { productId: item?._id },
      });
    } catch (error) {
    }
  };

  const decreaseQuantity = (item: any) => {
    try {
      store.dispatch({
        type: "basketSlice/decreaseQuantity",
        payload: { productId: item?._id },
      });
    } catch (error) {
    }
  };

  const ViderPanier = () => {
    try {
      store.dispatch({
        type: "basketSlice/delete",
        payload: {},
      });
      closeModal();
    } catch (error) {
    }
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const closeModalDelete = () => {
    setIsOpenDelete(false);
  };

  return (
    <div>
      <div>
        <NavBar page={"card"} />
      </div>

      <div className="cart-screen">
        <div className="cart-container">
          <div className="cart-operations-and-coupon">
            <div className="cart-operations">
              {productsInBasket?.length > 0 ? (
                <button
                  className="operation-button"
                  onClick={() => ViderPanierAction()}
                >
                  Vider le panier
                </button>
              ) : (
                <></>
              )}
            </div>
            <div className="coupon-code">
              <span>Code promo ?</span>
            </div>
          </div>
          <div className="cart-items-and-sammary">
            <div className="cart-items">
              {productsInBasket?.length > 0 ? (
                productsInBasket.map((item, index) => (
                  <div className="cart-item" key={index}>
                    {item?.sold > 0 && (
                      <div className="absolute-card-x">
                        {" "}
                        <span className="txt-abs-x"> sold {item?.sold} %</span>
                      </div>
                    )}
                    <div className="item-image">
                      <img
                        src={`${api}/${item.type}/photo/${item?._id}`}
                        alt="img"
                      />
                    </div>
                    <div className="item-details">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <span className="item-name" style={{ marginRight: 15 }}>
                          {item?.name} |{" "}
                        </span>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span
                            className="item-price"
                            style={
                              item?.sold > 0
                                ? { textDecoration: "line-through" }
                                : {}
                            }
                          >
                            {item?.price?.toFixed(3)} DT
                          </span>
                          {item?.sold > 0 ? (
                            <span className="item-price">
                              {(
                                (item?.price * (100 - item?.sold)) /
                                100
                              )?.toFixed(3)}{" "}
                              DT
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="quantity-controls">
                        {/* Add controls for quantity adjustment */}
                        <p
                          style={{
                            maxWidth: "100%",
                            fontSize: 16,
                            color: "#666",
                            fontWeight: 600,
                            marginBottom: 8,
                            textAlign: "start",
                            width: "90%",
                            display: "-webkit-box",
                            WebkitLineClamp: 2, // Limit to 2 lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item?.description}
                        </p>
                      </div>
                    </div>
                    <div className="item-actions" style={{ width: "20%" }}>
                      <div
                        className="trash-container"
                        onClick={() => deleteItem(item)}
                      >
                        <i
                          className="bx bx-trash"
                          style={{
                            fontSize: 32,
                            fontWeight: "700",
                            color: "#fd5555",
                          }}
                        ></i>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 10,
                          alignItems: "center",
                        }}
                      >
                        <button
                          disabled={item?.quantityInBasket == 1 ? true : false}
                          style={{
                            borderWidth: 0,
                            borderRadius: 9,
                            backgroundColor: "#fff",
                            width: 40,
                            height: 40,
                          }}
                          onClick={() => decreaseQuantity(item)}
                        >
                          <i className="bx bx-minus"></i>
                        </button>
                        <span className="number-txt">
                          {item?.quantityInBasket}
                        </span>
                        <button
                          style={{
                            borderWidth: 0,
                            borderRadius: 9,
                            backgroundColor: "#fff",
                            width: 40,
                            height: 40,
                          }}
                          onClick={() => increaseQuantity(item)}
                        >
                          <i className="bx bx-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-items-img-container">
                  <img
                    src="./../../assets/noItemsImage.png"
                    alt="noItems"
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
              )}
            </div>
            <div className="cart-summary">
              <h3>Résumé</h3>
              <div className="summary-total">
                <span className="total-txt">Totale </span>
                <span className="total-value">
                  {calculateTotal(productsInBasket)?.toFixed(3)} DT
                </span>
              </div>
              <button
                disabled={productsInBasket?.length > 0 ? false : true}
                className="checkout-btn"
                onClick={() => {
                  isAuthenticated ? navigate("/checkout") : navigate("/login");
                }}
              >
                {isAuthenticated ? "Payer" : "Connectez-vous pour payer"}
              </button>
              <button
                className="continue-shopping-btn"
                onClick={() => navigate("/shop")}
              >
                Continuer mes achats
              </button>
            </div>
          </div>
        </div>
        <div style={{marginTop : 15}}> 
          <h2>Produits récement consulter</h2>
        </div>
        <div ref={scrollContainerRef} className="horizontal-scroll-container">
          <ProductGrid />
        </div>
      </div>
      <div>
        <Footerr />
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalViderBasket
          text={"Êtes-vous sûr de vouloir vider le panier ?"}
          closeModal={closeModal}
          action={ViderPanier}
        />
      </Modal>
      <Modal
        isOpen={isOpenDelete}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalViderBasket
          text={`Êtes-vous sûr de vouloir supprimer ${itemToDelete?.name} ?`}
          closeModal={closeModalDelete}
          action={removeProdFromBasket}
        />
      </Modal>
    </div>
  );
}

export default CartScreen;
